import { ChatWarnings } from '@/store/chatWarning/chatWarning.types';
import { i18n } from '@/plugins/i18n';
import { ChatWarning } from './types';
import { formatString } from './bot/lib';

export function isChatWarningEnabled(chatWarnings: ChatWarnings, warningName: string): boolean {
  return chatWarnings[`${warningName}Enabled`] !== false;
}

export function getChatWarningText({
  chatWarnings,
  warningName,
  warningTextVariables,
  defaultTextLocale,
}: {
  chatWarnings: ChatWarnings;
  warningName: string;
  warningTextVariables?: Record<string, string>;
  defaultTextLocale: string;
}): string {
  const customText = chatWarnings[`${warningName}Text`];
  const hasCustomText = typeof customText === 'string' && customText.length > 0;

  if (typeof customText === 'string' && hasCustomText) {
    return formatString(customText, warningTextVariables || {});
  }

  return i18n.t(defaultTextLocale, warningTextVariables) as string;
}

export function getChatWarning({
  chatWarnings,
  warningName,
  warningTextVariables,
  defaultTextLocale,
  kind,
}: {
  chatWarnings: ChatWarnings;
  warningName: string;
  warningTextVariables?: Record<string, string>;
  defaultTextLocale: string;
  kind?: ChatWarning['kind'];
}): ChatWarning {
  return {
    show: isChatWarningEnabled(chatWarnings, warningName),
    message: getChatWarningText({
      chatWarnings,
      warningName,
      warningTextVariables,
      defaultTextLocale,
    }),
    kind,
    type: warningName,
  };
}
